export const dropdownStyle = {
  "& .MuiPaper-root": {
    width: "max-content",
    height: "fit-content",
    maxHeight: "50%",
    borderRadius: "var(--border-radius-dropdown)",
    overflowY: "auto",
  },
};
